// extracted by mini-css-extract-plugin
module.exports = {"advantageWrapper":"advantage-card_advantageWrapper__Boe0A","advantageTitle":"advantage-card_advantageTitle__FBw19"};